import { useEffect, useState } from 'react';
import { attachAdCustomizersHelpers } from './index';

export function useAdCustomizers({
  ref, updateAction, adType, container, field,
}) {
  const [cursorPosition, setCursorPostion] = useState(0);

  useEffect(() => {
    ref.current.setSelectionRange(cursorPosition, cursorPosition);
  }, [cursorPosition, ref]);


  useEffect(() => {
    const removeAdCustomizer = attachAdCustomizersHelpers({
      element: ref.current,
      updateAction,
      setCursorPostion,
      container,
      adType,
      field,
    });

    return () => removeAdCustomizer();
  }, [adType, container, field, ref, updateAction]);
}
